<template lang="pug">
include /@ibkr/lib.common/src/icon/basic
div(class="border-bottom insety-16")
    ib-row
        ib-col(class="xl2 s12")
            p(
                class="insety-16", 
                :class="{'insetx-4': !$media.m, 'insetx-8': $media.l, 'insetx-16': $media.xl}"
            )
                span(
                    class="insetx-8 info", 
                    :class="{'start-0': !$media.m}"
                )
                    +icon-basic-info_filled
                    span(class="tooltext") {{ $t('companies_by_group') }}
                span {{ $t('companies_by_group') }}
                br
                span(class="fs7 fg50", :class="{'insetx-8': $media.m}") ({{ $t('maximum_25') }})
        ib-col(
            class="xl10",
            :class="{ 'inset-16': $media.xl, 'insety-16': $media.s, 'insetx-16': $media.xl}"
            )
                ib-button(
                    v-if="groups.length === 0", 
                    class="add-edit comp-but",
                    @click="editGroup()",
                    :class="{'text-left': $media.s}",
                    tone="accent"
                ) {{ $t('add') }}/{{ $t('edit_companies') }}
                ul(v-else, class="start-16")
                    li(v-for="(group, index) in groups", :key="index")
                        p(class="before-16 border-bottom") Group {{ index + 1 }}
                        ib-table-basic(:data="group.companies", class="group-table")
                            ib-table-col(width="5ch")
                            ib-table-col(width="16ch") {{ $t('symbol') }}
                            ib-table-col {{ $t('name') }}
                            ib-table-col {{  $t('type') }}
                            template(slot="body", slot-scope="company")
                                td
                                    ib-checkbox(@click="toggleSelect(index, company.id)", :value="company.selected")
                                td {{ company.ticker }}
                                td {{ formatComp(company.name) }}
                                td(v-if="company.type === 'stocks'")
                                    span {{ $t('stock') }}
                                td(v-else-if="company.type === 'etfs'")
                                    span {{ $t('etf') }}
                        ib-button-group(class="before-8 after-8")
                            ib-button(@click="editGroup(index)", tone="accent", class="add-edit") {{ $t('add') }}/{{ $t('edit_companies') }}
                            ib-button(@click="editGroup()") {{ $t('add_group') }}
                            ib-button(v-if="groups.length > 1", @click="removeGroup(index)") {{ $t('delete_group') }}
    // Cannot use RegionTypes b/c that automatically updates global state.
    EditCompanies(ref="editCompanies", @update="update")
</template>

<script>

import cloneDeep from 'lodash.clonedeep';
import { mapState, mapActions } from 'vuex';
import {formatMixin} from '../js/formatting.js';
import EditCompanies from './EditCompanies.vue';

export default {
    name: 'SelectGroups',
    components: {
        EditCompanies
    },
    data() {
        return {
            selectedIndex: undefined,
            selectedGroup: undefined
        }
    },
    mixins: [formatMixin],
    methods: {
        // Adds new group if index is undefined, otherwise edit
        editGroup(index) {
            if (index === undefined) index = this.groups.length;
            if (index === this.groups.length) {
                const newGroup = {
                    companies: []
                };
                this.selectedGroup = newGroup;
            } else {
                this.selectedGroup = cloneDeep(this.groups[index]);
            }

            if (index >= 5) {
                $alert(this.$t('max_groups'));
                return;
            }

            this.selectedIndex = index;
            this.$refs.editCompanies.open(this.selectedGroup.companies);
        },
        // Called from @updated from editCompanies component
        update(companies) {
            console.debug('Update Called...', companies);
            // if (!companies || companies.length === 0) return;
            this.selectedGroup.companies = companies;
            const index = this.selectedIndex;

            if (this.selectedGroup.companies.length === 0) {
                console.debug('Deleteing group', index);
                this.deleteGroup(index);
            } else {
                this.updateGroup({index, companies});
            }
        },
        // Wrapper function because you cannot do an inline handler and pass an object
        toggleSelect(index, id) {
            this.toggleCompanySelection({index, id});
        },
        removeGroup(index) {
            this.deleteGroup(index);
        },
        reset() {
            console.log('Reset groups');
            this.resetGroups();
        },
        ...mapActions(['toggleCompanySelection', 'updateGroup', 'deleteGroup', 'resetGroups'])
    },
    computed: {
        ...mapState(['groups'])
    },
}
</script>

<style lang="less" scoped>
    .group-table {
        border-bottom: 1px solid #d1d1d1;
    }
    .comp-but {
        margin-left: 16px;
    }
    .add-edit {
        &:hover {
            background: #000;
        }
    }
    @media (max-width: 768px) {
        .comp-but {
            width: calc(100% - 8px);
            margin: auto;
            display: block;
        }
    }
    
</style>>